import { ActionableStore } from 'native_bridge/types'

export const BRIDGED_LINK_TYPE_ATTRIBUTE = 'data-bridged-link'

export const createClickListener = (store: ActionableStore): ((e: Event) => void) => {
  return (e: Event): void => {
    const clickTarget = e.target as HTMLElement
    // only process anchor tags
    const target = clickTarget.closest('a')
    if (!target) return
    // only process anchor tags with our special class
    if (target && target.hasAttribute(BRIDGED_LINK_TYPE_ATTRIBUTE)) {
      const anchorHref = target.getAttribute('href')
      const anchorTarget = target.getAttribute('target')
      const linkType = target.getAttribute(BRIDGED_LINK_TYPE_ATTRIBUTE)
      store.dispatch('nativeApp/openLink', {
        linkType,
        target: anchorTarget,
        url: anchorHref,
      })
    }
  }
}
